import React, { useEffect, useMemo, useRef, useState } from 'react';
import WeeklyFigures from './WeeklyFigures.tsx';
import '../../../styles/admin/Week.css';
import { IoMdSettings } from 'react-icons/io';
import {
    getBetsByIds,
    getPendingBetsForPlayer,
    getTransactionsByIds,
    getVimplayTransactionsByIds,
    pendingBets,
    WeeklyFiguresData,
} from '../../../services/admin/BetsService.tsx';
import { editUser } from '../../../services/admin/UserService.tsx';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
import TableHeader from './TableHeader.tsx';
import { RiFileExcel2Line } from 'react-icons/ri';
import { MdOutlinePictureAsPdf } from 'react-icons/md';
import { IoIosClose } from 'react-icons/io';
import { BetDetails } from '../../../models/MyBetModel.tsx';
import { MdArrowDropDown } from 'react-icons/md';
import { IoClose } from 'react-icons/io5';
import { formatNumbers, getBetResultDelta, isPropsBet } from '../../../helpers/functions.tsx';
import { Transaction, UserGroups, Users } from '../../../models/User.tsx';
import { readWeeklyAccountViewSession, writeWeeklyAccountViewSession } from '../../../helpers/weeklyFiguresSelectors.tsx';
import BetsDetails from './BetsDetails.tsx';
import { Modal } from 'bootstrap';
import { useTableColumns } from './useTableColumns.tsx';
import { useUser } from '../../../context/UserContext.tsx';
import { TransactionDetails } from './TransactionDetails.tsx';
import { CasinoTransactionDetails } from './CasinoTransactionDetails.tsx';
import { VimplayTransaction } from '../../../models/VimplayTransaction.tsx';
import { DepositWithdrawalDetails } from './DepositWithdrawalDetails.tsx';
import {
    getAdminStartOfWeek as getStartOfWeek,
    getAdminEndOfWeek as getEndOfWeek,
    getAdminWeekDays as getWeekDays,
    getAdminCurrentWeekRange as getCurrentWeekRange,
    getAdminPastWeekRanges as getPastWeekRanges,
    getAdminWeekRangeWeeksAgo as getWeekRangeWeeksAgo,
} from '../../../helpers/adminWeeklyWeekUtils.tsx';
import {
    getAdminFiguresWeekdayIndex as getFiguresWeekdayIndex,
    formatAdminFiguresDateLabel as formatFiguresDateLabel,
    getAdminFiguresZonedParts as getFiguresZonedParts,
    formatAdminFiguresDateTime as formatFiguresDateTime,
    formatAdminFiguresTime as formatFiguresTime,
    getAdminFiguresDateKey as getFiguresDateKey,
} from '../../../helpers/adminFiguresTime.tsx';
import { FaSyncAlt } from 'react-icons/fa';
import { trace } from 'firebase/performance';
import { perf } from '../../../services/Firebase.js';

type WeekRange = { start: Date; end: Date };
type FilterKey =
    | 'password'
    | 'dailyWinLoss'
    | 'endOfWeekBalance'
    | 'pendingBalance'
    | 'depositsWithdrawals'
    | 'lastWager'
    | 'lastLogin';

const DAY_KEYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;
const DAY_NAMES = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'] as const;

const REPORT_FILTERS: { key: FilterKey; label: string; id: string }[] = [
    { key: 'password', label: 'Password', id: 'checkPass' },
    { key: 'dailyWinLoss', label: 'Daily Win/Loss Figure', id: 'checkDaily' },
    { key: 'endOfWeekBalance', label: 'End of Week Balance', id: 'checkWeek' },
    { key: 'pendingBalance', label: 'Pending Balance', id: 'checkPending' },
    { key: 'depositsWithdrawals', label: 'Deposits/Withdrawals', id: 'checkDeposits' },
    { key: 'lastWager', label: 'Last Wager Placed', id: 'checkWager' },
    { key: 'lastLogin', label: 'Last Login', id: 'checkLogin' },
];

const sortByUserName = <T extends { userName?: string }>(list: T[]) =>
    [...list].sort((a, b) =>
        (a.userName || '').localeCompare(b.userName || '', undefined, { numeric: true, sensitivity: 'base' })
    );

const metricClass = (value: number) =>
    value < 0 ? 'negative-admin' : value > 0 ? 'positive-admin' : '';

const formatDay = (date: Date) => {
    const parts = getFiguresZonedParts(date);
    return `${String(parts.month).padStart(2, '0')}/${String(parts.day).padStart(2, '0')}`;
};

const formatDateTime = (timestamp: any) => {
    if (!timestamp?.seconds) return;
    return formatFiguresDateTime(new Date(timestamp.seconds * 1000));
};

const isParlayOrTeaser = (bet: BetDetails) =>
    bet.betType === 'Parlay' || bet.betType === 'Teaser';

const showBetDetailModal = () => {
    const modalElement = document.getElementById('betDetail');
    if (!modalElement) return;
    (Modal.getInstance(modalElement) ?? new Modal(modalElement)).show();
};

const Weekly = () => {
    const { user: currentUser, userIpData: userIpDataAdmin, updateUser } = useUser();
    const isMaster = currentUser?.userType === 'masterAgent';

    const [previousWeeks, setPreviousWeeks] = useState<string[]>([]);
    const [selectedOption, setSelectedOption] = useState(readWeeklyAccountViewSession);
    const [filters, setFilters] = useState<Users['filters'] | undefined>(currentUser?.filters);
    const filtersRef = useRef(filters);
    filtersRef.current = filters;
    const [selectedWeek, setSelectedWeek] = useState<'thisWeek' | 'lastWeek' | string>('thisWeek');
    const [weekRange, setWeekRange] = useState<WeekRange | null>(null);
    const [selectedWeeks, setSelectedWeeks] = useState('previousWeeks');
    const [expandedPlayers, setExpandedPlayers] = useState<Set<string>>(new Set());
    const [details, setDetails] = useState<BetDetails[]>([]);
    const [detailsTransactions, setDetailsTransactions] = useState<Transaction[]>([]);
    const [detailsCasino, setDetailsCasino] = useState<VimplayTransaction[]>([]);
    const [detailPlayerId, setDetailPlayerId] = useState<string | null>(null);
    const [playerTransactionsDepositWithdrawal, setPlayerTransactionsDepositWithdrawal] = useState<Transaction[]>([]);
    const [detailsDates, setDetailsDates] = useState('');
    const [modalResultTotal, setModalResultTotal] = useState(0);
    const [modalLoading, setModalLoading] = useState(false);
    const [modalKind, setModalKind] = useState<'figures' | 'pending' | 'deposits'>('figures');
    const [weeklyData, setWeeklyData] = useState<WeeklyFiguresData | undefined>();
    const [isLoading, setIsLoading] = useState(true);
    const [appliedWeekKey, setAppliedWeekKey] = useState('');
    const [currentColumnIndex, setCurrentColumnIndex] = useState(0);

    const weekKey = currentUser && weekRange
        ? `${currentUser.userName}:${weekRange.start.getTime()}:${weekRange.end.getTime()}`
        : '';

    useEffect(() => {
        setWeekRange(getCurrentWeekRange());
        setSelectedWeek('thisWeek');
    }, []);

    useEffect(() => {
        if (!currentUser?.filters) return;
        if (filtersRef.current) return;
        setFilters(currentUser.filters);
    }, [currentUser]);

    useEffect(() => {
        if (!currentUser || !weekRange || !weekKey) return;

        let cancelled = false;

        const loadWeekly = async () => {
            setIsLoading(true);

            
            const t = trace(perf, 'loadWeekly');
            t.start();

            try {
                const data = await pendingBets(currentUser, weekRange.start);
                if (cancelled) return;
                setWeeklyData(data);
                setAppliedWeekKey(weekKey);
            } catch (error) {
                console.error('Error loading weekly figures:', error);
            } finally {
                t.stop();
                if (!cancelled) setIsLoading(false);
            }
        };

        void loadWeekly();

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [weekKey]);

    useEffect(() => {
        const modalEl = document.getElementById('betDetail');
        if (!modalEl) return;

        const handleShow = () => {
            setTimeout(() => {
                const backdrop = document.querySelector('.modal-backdrop') as HTMLElement | null;
                if (!backdrop) return;
                backdrop.style.backgroundColor = '#297a9f';
                backdrop.style.opacity = '1';
                backdrop.style.transition = 'none';
            }, 0);
        };

        const handleHidden = () => {
            setModalLoading(false);
            document.querySelector('.modal-backdrop')?.remove();
        };

        modalEl.addEventListener('show.bs.modal', handleShow);
        modalEl.addEventListener('hidden.bs.modal', handleHidden);
        return () => {
            modalEl.removeEventListener('show.bs.modal', handleShow);
            modalEl.removeEventListener('hidden.bs.modal', handleHidden);
        };
    }, []);

    useEffect(() => {
        if (!weekRange) return;
        const today = new Date();
        const inCurrentWeek = today >= weekRange.start && today <= weekRange.end;
        setCurrentColumnIndex(inCurrentWeek ? getFiguresWeekdayIndex(today) : 7);
    }, [weekRange]);

    const players = weeklyData?.players ?? [];
    const subAgents = weeklyData?.subAgents ?? [];
    const dailyTotals = weeklyData?.dailyTotals ?? {};
    const totalPendingPlayer = weeklyData?.totalPendingAmountPerPlayer ?? {};
    const depositsWithdrawalsByPlayer = weeklyData?.depositsWithdrawalsByPlayer ?? {};
    const detailIdsByPlayer = weeklyData?.detailIdsByPlayer ?? {};

    const weekDays = weekRange ? getWeekDays(weekRange.start) : [];
    const weekDayNames = weekDays.map(day => formatFiguresDateLabel(day, { weekday: 'long' }));
    const { isVisible } = useTableColumns(filters, currentColumnIndex);

    const pastWeekOptions = useMemo(
        () =>
            getPastWeekRanges(28).map((range, index) => {
                const weeksAgo = index + 1;
                return {
                    label: weeksAgo === 1 ? 'Last week' : `${weeksAgo} Week's ago`,
                    value: { start: range.start, end: range.end, days: getWeekDays(range.start) },
                };
            }),
        [],
    );

    const filterPlayers = (list: Users[]) => {
        let filtered = list;

        if (selectedOption === 'With') {
            filtered = list.filter(player => player.balance !== 0);
        } else if (selectedOption === 'Active') {
            filtered = list.filter(player => {
                const ids = detailIdsByPlayer[player.id!];
                return (ids?.allBetIds?.length ?? 0) > 0 ||
                    (ids?.allAdjustmentIds?.length ?? 0) > 0 ||
                    (ids?.allCasinoIds?.length ?? 0) > 0;
            });
        } else if (selectedOption === 'Big') {
            filtered = list.filter(player => (player.balance ?? 0) > 400);
        }

        return sortByUserName(filtered);
    };

    const filteredPlayers = filterPlayers(players);
    const totalPlayers = filteredPlayers.length;
    const totalPendingsAmount = filteredPlayers.reduce(
        (total, player) => total + (totalPendingPlayer[player.id!] || 0),
        0,
    );
    const totalBalance = filteredPlayers.reduce((sum, player) => sum + (player.balance || 0), 0);
    const totalWeekly = filteredPlayers.reduce(
        (sum, player) => sum + (dailyTotals[player.id!]?.weeklyTotal || 0),
        0,
    );
    const totalWeeklyDepositsWithdrawals = filteredPlayers.reduce(
        (total, player) => total + (depositsWithdrawalsByPlayer[player.id!] || 0),
        0,
    );
    const totalDailyBalances = weekDayNames.map(day =>
        filteredPlayers.reduce((total, player) => total + (dailyTotals[player.id!]?.[day] || 0), 0),
    );

    const sortedCustomer: UserGroups = {
        players,
        subAgents: sortByUserName(subAgents),
    };

    const trackPreviousWeek = (newDate: Date) => {
        const dateKey = newDate.toISOString();
        if (previousWeeks.length === 0) {
            setPreviousWeeks([dateKey]);
            return;
        }

        const lastWeek = new Date(
            [...previousWeeks].sort((a, b) => new Date(a).getTime() - new Date(b).getTime()).at(-1)!,
        );
        const daysDiff = (newDate.getTime() - lastWeek.getTime()) / (1000 * 3600 * 24);
        if (daysDiff >= 7) setPreviousWeeks([...previousWeeks, dateKey]);
    };

    const handleCurrentWeek = () => {
        setWeekRange(getCurrentWeekRange());
        setSelectedWeek('thisWeek');
        setSelectedWeeks('previousWeeks');
    };

    const handlePrevWeek = () => {
        const { start, end } = getWeekRangeWeeksAgo(1);
        trackPreviousWeek(start);
        setWeekRange({ start, end });
        setSelectedWeek('lastWeek');
        const lastOption = pastWeekOptions[0];
        setSelectedWeeks(lastOption ? JSON.stringify(lastOption.value) : 'previousWeeks');
    };

    const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        setSelectedWeeks(value);

        if (value === 'previousWeeks') {
            setWeekRange(getCurrentWeekRange());
            setSelectedWeek('thisWeek');
            return;
        }

        const weekData = JSON.parse(value);
        if (weekData.days.every((day: string) => !Number.isNaN(Date.parse(day)))) {
            const start = new Date(weekData.start);
            const end = new Date(weekData.end);
            const lastWeek = getWeekRangeWeeksAgo(1);
            const isLastWeek = start.getTime() === lastWeek.start.getTime();
            setWeekRange({ start, end });
            setSelectedWeek(isLastWeek ? 'lastWeek' : 'other');
        }
    };

    const handleFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        setSelectedOption(value);
        writeWeeklyAccountViewSession(value);
    };

    const handleFilterToggle = (filterKey: FilterKey) => {
        setFilters(prev => {
            if (!prev) return prev;
            return { ...prev, [filterKey]: !Boolean(prev[filterKey]) };
        });
    };

    const handleApplyClick = async () => {
        if (!filters || !currentUser?.id) return;
        try {
            filtersRef.current = filters;
            await editUser(currentUser.id, { filters });
            updateUser({ filters });
        } catch (error) {
            console.error('Failed to update filters:', error);
        }
    };

    const resetModalState = (
        playerId: string,
        kind: 'figures' | 'pending' | 'deposits' = 'figures',
    ) => {
        setDetails([]);
        setDetailsTransactions([]);
        setDetailsCasino([]);
        setDetailPlayerId(playerId);
        setPlayerTransactionsDepositWithdrawal([]);
        setModalKind(kind);
        setModalLoading(true);
        showBetDetailModal();
    };

    const handleDayDetailClick = async (playerId: string, targetDate: Date) => {
        const dateKey = getFiguresDateKey(targetDate);
        const ids = detailIdsByPlayer[playerId];
        const dayName = formatFiguresDateLabel(targetDate, { weekday: 'long' });
        const parts = getFiguresZonedParts(targetDate);

        setDetailsDates(`${dayName} (${parts.month}/${parts.day})`);
        setModalResultTotal(dailyTotals[playerId]?.[DAY_NAMES[getFiguresWeekdayIndex(targetDate)]] ?? 0);
        resetModalState(playerId, 'figures');

        try {
            const [bets, txs, casino] = await Promise.all([
                getBetsByIds(ids?.betIdsByDate[dateKey] || []),
                getTransactionsByIds(ids?.adjustmentIdsByDate[dateKey] || []),
                getVimplayTransactionsByIds(ids?.casinoIdsByDate[dateKey] || []),
            ]);
            setDetails(bets);
            setDetailsTransactions(txs);
            setDetailsCasino(casino);
        } finally {
            setModalLoading(false);
        }
    };

    const handleWeekDetailClick = async (playerId: string, targetDate: Date) => {
        const ids = detailIdsByPlayer[playerId];
        const start = getStartOfWeek(targetDate);
        const end = getEndOfWeek(targetDate);
        const format = (d: Date) => {
            const p = getFiguresZonedParts(d);
            return `${p.day}/${p.month}/${p.year}`;
        };

        setDetailsDates(`${format(start)} - ${format(end)}`);
        setModalResultTotal(dailyTotals[playerId]?.weeklyTotal ?? 0);
        resetModalState(playerId, 'figures');

        try {
            const [bets, txs, casino] = await Promise.all([
                getBetsByIds(ids?.allBetIds || []),
                getTransactionsByIds(ids?.allAdjustmentIds || []),
                getVimplayTransactionsByIds(ids?.allCasinoIds || []),
            ]);
            setDetails(bets);
            setDetailsTransactions(txs);
            setDetailsCasino(casino);
        } finally {
            setModalLoading(false);
        }
    };

    const handleDepositsDetailClick = async (playerId: string) => {
        setDetailsDates('');
        setModalResultTotal(0);
        resetModalState(playerId, 'deposits');

        try {
            const txs = await getTransactionsByIds(detailIdsByPlayer[playerId]?.depositWithdrawalIds || []);
            setPlayerTransactionsDepositWithdrawal(txs);
        } finally {
            setModalLoading(false);
        }
    };

    const handlePendingDetailClick = async (playerId: string) => {
        const ids = detailIdsByPlayer[playerId]?.pendingBetIds || [];

        setDetailsDates('Pending');
        setModalResultTotal(totalPendingPlayer[playerId] || 0);
        resetModalState(playerId, 'pending');

        try {
            const bets = ids.length > 0
                ? await getBetsByIds(ids)
                : await getPendingBetsForPlayer(playerId);
            setDetails(bets);
        } finally {
            setModalLoading(false);
        }
    };

    const togglePlayerDetails = (key: string) => {
        setExpandedPlayers(prev => {
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    };

    const generatePDF = () => {
        const input = document.querySelector('.weekly') as HTMLElement | null;
        if (!input) return;

        html2canvas(input, { scale: 2 }).then(canvas => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgWidth = 210;
            const pageHeight = 295;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            const parts = getFiguresZonedParts(new Date());
            const today = `${String(parts.day).padStart(2, '0')}-${String(parts.month).padStart(2, '0')}-${parts.year}`;
            pdf.save(`WeeklyFigures_${today}.pdf`);
        });
    };

    const exportToExcel = () => {
        const input = document.querySelector('.weekly');
        if (!input) return;

        const ws = XLSX.utils.table_to_sheet(input.cloneNode(true) as HTMLElement);
        ws['!cols'] = Array.from({ length: 17 }, () => ({ wpx: 125 }));

        const range = XLSX.utils.decode_range(ws['!ref'] || 'A1');
        for (let row = range.s.r + 1; row <= range.e.r; row += 1) {
            const cell = ws[XLSX.utils.encode_cell({ r: row, c: 1 })];
            if (cell && typeof cell.v === 'number') {
                cell.t = 's';
                cell.v = cell.v.toString();
            }
        }

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, currentUser?.userName);

        const today = new Date();
        const formattedDate = formatFiguresDateLabel(today, { year: 'numeric', month: 'long', day: 'numeric' });
        const formattedTime = formatFiguresTime(today, { hour: 'numeric', minute: '2-digit' })
            .replace(':', '_')
            .replace(' ', '');

        XLSX.writeFile(wb, `WeeklyFigures_ ${formattedDate.replace(',', '')} ${formattedTime}.xlsx`);
    };

    const isWeekContentPending = Boolean(weekKey) && appliedWeekKey !== weekKey;
    const showPageLoader = !weeklyData || isLoading || isWeekContentPending;
    const hasModalData =
        details.length > 0 || detailsTransactions.length > 0 || detailsCasino.length > 0 || playerTransactionsDepositWithdrawal.length > 0;
    const modalPlayer = players.find(player => player.id === detailPlayerId);
    const modalUserName = details[0]?.player?.userName ?? detailsCasino[0]?.user ?? modalPlayer?.userName;
    const modalPin = details[0]?.player?.pin ?? modalPlayer?.pin;

    if (showPageLoader) {
        return (
            <div className="weekly-page-loader">
                <FaSyncAlt className="loader-icon-proyect" />
            </div>
        );
    }

    return (
        <>
            <div className="container-fluid">
                <div className="mt-1 container-body">
                    <div className="admin">
                        <div>
                            <button
                                id="current-week-button"
                                name="currentWeekButton"
                                onClick={handleCurrentWeek}
                                className={`button-weekly${selectedWeek === 'thisWeek' ? ' is-active' : ''}`}
                                aria-pressed={selectedWeek === 'thisWeek'}
                            >
                                This Week
                            </button>
                            <button
                                id="previous-week-button"
                                name="previousWeekButton"
                                onClick={handlePrevWeek}
                                className={`button-weekly${selectedWeek === 'lastWeek' ? ' is-active' : ''}`}
                                aria-pressed={selectedWeek === 'lastWeek'}
                            >
                                Last Week
                            </button>
                            <div className={`select-wrapper ${selectedWeeks !== 'previousWeeks' ? 'line-week' : ''}`}>
                                <select
                                    id="select-week"
                                    name="selectWeek"
                                    onChange={handleSelectChange}
                                    value={selectedWeeks}
                                    className="select-weekly"
                                >
                                    <option value="previousWeeks">This week</option>
                                    {pastWeekOptions.map((week, index) => (
                                        <option key={index} value={JSON.stringify(week.value)}>
                                            {week.label}
                                        </option>
                                    ))}
                                </select>
                                <span><MdArrowDropDown className="arrow" /></span>
                            </div>
                        </div>

                        <div className="panel-tools">
                            <div className="select-wrapper panel-toolspanel-tools">
                                <select
                                    id="select-filter"
                                    name="selectfilter"
                                    className="select-filter"
                                    value={selectedOption}
                                    onChange={handleFilterChange}
                                >
                                    <option value="Active">Active for the week</option>
                                    <option value="With">With A Balance</option>
                                    <option value="All">All Players</option>
                                    <option value="Big">Big Figures</option>
                                </select>
                                <span><MdArrowDropDown className="arrow" /></span>
                            </div>
                            <button type="button" className="buttonSetting" data-bs-toggle="modal" data-bs-target="#settingWeekly">
                                <IoMdSettings />
                            </button>
                            <span onClick={generatePDF}>
                                <MdOutlinePictureAsPdf className="pdf-icon" />
                            </span>
                            <span onClick={exportToExcel}>
                                <RiFileExcel2Line className="excel-icon" />
                            </span>
                        </div>
                    </div>

                    <div className="weekly">
                        <div className="table-responsive">
                            {isMaster && (
                                <div className="weekly-table-wrap">
                                    <table className="table players-table table-custom">
                                        <TableHeader
                                            weekDays={weekDays}
                                            formatDay={formatDay}
                                            filters={filters}
                                            currentColumnIndex={currentColumnIndex}
                                            setCurrentColumnIndex={setCurrentColumnIndex}
                                        />
                                        <tbody className="body-color">
                                            <tr>
                                                <td className="text-left-important weekly-customer-cell">
                                                    <div className="weekly-customer-text">{totalPlayers} Players</div>
                                                </td>
                                                {filters?.password && <td className="none" />}
                                                {filters?.dailyWinLoss && totalDailyBalances.map((total, index) => {
                                                    const dayName = DAY_KEYS[index];
                                                    if (!isVisible(dayName)) return null;
                                                    return (
                                                        <td
                                                            key={dayName}
                                                            className={`col-${dayName} weekly-metric-cell ${metricClass(total)} letter-right`}
                                                        >
                                                            {formatNumbers(total)}
                                                        </td>
                                                    );
                                                })}
                                                {isVisible('week') && (
                                                    <td className={`col-week weekly-metric-cell ${metricClass(totalWeekly)} letter-right`}>
                                                        {formatNumbers(totalWeekly)}
                                                    </td>
                                                )}
                                                {filters?.pendingBalance && isVisible('pending') && (
                                                    <td className="col-pending weekly-metric-cell letter-right">
                                                        ${formatNumbers(totalPendingsAmount)}
                                                    </td>
                                                )}
                                                {filters?.depositsWithdrawals && isVisible('depositsWithdrawal') && (
                                                    <td className={`col-depositsWithdrawal weekly-metric-cell letter-right ${metricClass(totalWeeklyDepositsWithdrawals)}`}>
                                                        {formatNumbers(totalWeeklyDepositsWithdrawals)}
                                                    </td>
                                                )}
                                                {filters?.endOfWeekBalance && (
                                                    <td className={`weekly-balance-cell ${metricClass(totalBalance)} letter-right`}>
                                                        {formatNumbers(totalBalance)}
                                                    </td>
                                                )}
                                                {filters?.lastLogin && <td className="none" />}
                                                {filters?.lastWager && <td className="none" />}
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            <WeeklyFigures
                                customer={sortedCustomer}
                                weekDays={weekDays}
                                formatDay={formatDay}
                                filterPlayers={filterPlayers}
                                filters={filters}
                                totalPendingPlayer={totalPendingPlayer}
                                totalPendingsAmount={totalPendingsAmount}
                                dailyTotals={dailyTotals}
                                detailIdsByPlayer={detailIdsByPlayer}
                                currentUser={currentUser}
                                currentColumnIndex={currentColumnIndex}
                                setCurrentColumnIndex={setCurrentColumnIndex}
                                userIpDataAdmin={userIpDataAdmin}
                                weeklyDepositsWithdrawalsByPlayer={depositsWithdrawalsByPlayer}
                                onDayClick={handleDayDetailClick}
                                onWeekClick={handleWeekDetailClick}
                                onDepositsWithdrawalsClick={handleDepositsDetailClick}
                                onPendingClick={handlePendingDetailClick}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal" id="betDetail" tabIndex={-1}>
                <div className="modal-dialog modal-lg modal-fullscreen-sm-down">
                    <div className="modal-content modal-content-modal">
                        <div className="user-container-modal">
                            {modalUserName && (
                                <div>
                                    <span className="user-name-details">{modalUserName}</span>
                                    <span className="user-pin-details">{modalPin}</span>
                                </div>
                            )}
                            <IoClose data-bs-dismiss="modal" aria-label="Close" style={{ fontSize: '24px' }} />
                        </div>

                        <div className="show-modal-body-fixture">
                            <div className="spacing-table">
                                <div className="table-wrapper">
                                    {modalLoading ? (
                                        <div className="loader-container-modal">
                                            <FaSyncAlt className="loader-icon-proyect" />
                                        </div>
                                    ) : hasModalData ? (
                                        <>
                                            {(details.length > 0 || detailsTransactions.length > 0 || detailsCasino.length > 0) && (
                                                <>
                                                    <div className="bets-summary">
                                                        <span className="body-title padding">
                                                            Wagers: <span className="fw-bold padding">{details.length}</span>
                                                        </span>
                                                        <span className="body-title">
                                                            {modalKind === 'pending' ? 'Pending:' : 'Result:'}
                                                            &nbsp;
                                                            <span
                                                                className={
                                                                    modalKind === 'pending'
                                                                        ? 'black-letters'
                                                                        : `${modalResultTotal > 0 ? 'positive' : modalResultTotal < 0 ? 'negative' : 'zero'} black-letters`
                                                                }
                                                            >
                                                                {modalKind === 'pending'
                                                                    ? `$${formatNumbers(Math.abs(modalResultTotal))}`
                                                                    : `${modalResultTotal > 0 ? '+ $' : modalResultTotal < 0 ? '- $' : '$'}${formatNumbers(Math.abs(modalResultTotal))}`}
                                                            </span>
                                                        </span>
                                                    </div>
                                                    <table className="table-bet mt-1">
                                                        <thead className="table-title-modal">
                                                            <tr>
                                                                <th>{detailsDates}</th>
                                                                <th />
                                                                <th className="text-end">{modalKind === 'pending' ? 'Risk' : 'Amount'}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="body-customer customer-weekly">
                                                            <BetsDetails
                                                                details={details}
                                                                isParlay={isParlayOrTeaser}
                                                                togglePlayerDetails={togglePlayerDetails}
                                                                getResult={getBetResultDelta}
                                                                expandedPlayers={expandedPlayers}
                                                                formatDateTime={formatDateTime}
                                                                isProps={isPropsBet}
                                                                amountMode={modalKind === 'pending' ? 'risk' : 'result'}
                                                            />
                                                            {modalKind !== 'pending' && (
                                                                <TransactionDetails
                                                                    transactions={detailsTransactions}
                                                                    startIndex={details.length}
                                                                />
                                                            )}
                                                            {modalKind !== 'pending' && (
                                                                <CasinoTransactionDetails
                                                                    transactions={detailsCasino}
                                                                    startIndex={details.length + detailsTransactions.length}
                                                                />
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </>
                                            )}
                                            {playerTransactionsDepositWithdrawal.length > 0 && (
                                                <DepositWithdrawalDetails transactions={playerTransactionsDepositWithdrawal} />
                                            )}
                                        </>
                                    ) : (
                                        <div className="text-center py-4">No data for this period.</div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="button-close-modal-container">
                            <button className="button-close-modal" data-bs-dismiss="modal" aria-label="Close">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade modal-sm" id="settingWeekly" tabIndex={-1}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-title-acount">
                            <span className="font-account">Report Setting</span>
                            <IoIosClose className="close-icon" size={42} data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="container-account">
                            {REPORT_FILTERS.map(({ key, label, id }) => (
                                <div className="container-setting" key={key}>
                                    <span className="font-size">{label}</span>
                                    <div className="form-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={id}
                                            checked={Boolean(filters?.[key])}
                                            onChange={() => handleFilterToggle(key)}
                                        />
                                    </div>
                                </div>
                            ))}
                            <div className="container-setting export-excel">
                                <span className="font-size mt-1">Export Excel</span>
                                <div className="d-flex align-items-center justify-content-center">
                                    <span onClick={exportToExcel}>
                                        <RiFileExcel2Line className="excel-icon" />
                                    </span>
                                </div>
                            </div>
                            <div className="container-setting export-print">
                                <span className="font-size mt-1">Print</span>
                                <div className="d-flex align-items-center justify-content-center">
                                    <span onClick={generatePDF}>
                                        <MdOutlinePictureAsPdf className="pdf-icon" />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer d-flex justify-content-center">
                            <button type="button" className="btn btn-success" onClick={handleApplyClick} data-bs-dismiss="modal">
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Weekly;
